import { render, staticRenderFns } from "./ChangeKennelOwnerCard.vue?vue&type=template&id=43f5599f"
import script from "./ChangeKennelOwnerCard.vue?vue&type=script&lang=ts"
export * from "./ChangeKennelOwnerCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports